import { render } from "./root.vue?vue&type=template&id=235aa71e&scoped=true"
import script from "./root.vue?vue&type=script&lang=js"
export * from "./root.vue?vue&type=script&lang=js"

import "./root.vue?vue&type=style&index=0&id=235aa71e&scoped=true&lang=css"
import "./root.vue?vue&type=style&index=1&id=235aa71e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235aa71e"]])

export default __exports__